export default __webpack_public_path__ + "static/media/client-10.1c964d50.png";